module.exports = __webpack_public_path__ + "img/login.237ec337.svg";